import {Component, Fragment} from 'react'
import {toastr} from "react-redux-toastr"
import nl2br from 'react-nl2br'
import { isEmpty, isEqual } from '../../../../../shared/services/lodashInJS.js'
import { parseISO, isAfter } from 'date-fns'
import Plus from 'react-feather/dist/icons/plus.js'
import Edit from 'react-feather/dist/icons/edit.js'
import Trash from 'react-feather/dist/icons/trash.js'

import handleResponseErrors from '../../../../services/processServerErrors.js'

import conf from "../../../../conf.js"
import api from "../../../../../api.js"
import Date from '../../../../../shared/components/Moment/Date.jsx'
import Loader from '../../../../../shared/components/Loader/Loader.jsx'
import connectModal from '../../../../../shared/components/Modals/connect.js'
import CardRow from "../../../../../shared/components/Styled/Card/CardRow.jsx"
import CardCol from "../../../../../shared/components/Styled/Card/CardCol.jsx"
import ItSkillModal from "../../../../../shared/components/Modals/ItSkill/ItSkillModal.jsx"
import ItSkillForm from "../../../../../shared/components/Forms/ItSkillForm/ItSkillForm.jsx"

import CertificationForm from '../../../../components/Forms/CertificationForm/CertificationForm.jsx'
import LanguageForm from "../../../../components/Forms/LanguageForm/LanguageForm.jsx"
import DiplomeModal from '../../../../components/Modals/Diplome/DiplomeModal.jsx'
import DeleteDiplomeModal from '../../../../components/Modals/Diplome/DeleteDiplomeModal.jsx'

import FreelancePage from "../../../../../shared/components/Styled/Containers/FreelancePage.jsx"

import './Formations.scss'

export class Formations extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      degrees: this.sortChronologically(this.props.freelance?.diplomes?.length ? this.props.freelance.diplomes : []),
      certifications: this.sortChronologically(this.props.freelance?.certifications?.length ? this.props.freelance.certifications : []),
      itSkills: this.props.freelance?.it_skills?.length ? this.props.freelance.it_skills : [],
      languages: this.props.freelance?.languages?.length ? this.props.freelance.languages : [],
      languageLevels: Object.values(conf.languageLevels).reduce(
        (acc, curr) => {
          acc[curr.value] = curr.label
          return acc
        },
        []
      ),
    }
  }

  componentDidMount() {
    if (window.location.hash) {
      setTimeout(() => {
        window.history.replaceState(null, '', window.location.pathname + window.location.search)
      }, 0)
    }
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    const prevDegrees = prevProps.freelance?.diplomes?.length ? prevProps.freelance.diplomes : []
    const degrees = this.props.freelance?.diplomes?.length ? this.props.freelance.diplomes : []
    if (!isEqual(prevDegrees, degrees)) {
      this.setState({
        degrees: this.sortChronologically(degrees)
      })
    }
    const prevCertifications = prevProps.freelance?.certifications?.length ? prevProps.freelance.certifications : []
    const certifications = this.props.freelance?.certifications?.length ? this.props.freelance.certifications : []
    if (!isEqual(prevCertifications, certifications)) {
      this.setState({
        certifications: this.sortChronologically(certifications)
      })
    }

    const prevItSkills = prevProps.freelance?.it_skills?.length ? prevProps.freelance.it_skills : []
    const itSkills = this.props.freelance?.it_skills?.length ? this.props.freelance.it_skills : []
    if (!isEqual(prevItSkills, itSkills)) {
      this.setState({itSkills:this.sortChronologically( itSkills)})
    }

    const prevLanguages = prevProps.freelance?.languages?.length ? prevProps.freelance.languages : []
    const languages = this.props.freelance?.languages?.length ? this.props.freelance.languages : []
    if (!isEqual(prevLanguages, languages)) {
      this.setState({ languages })
    }
  }

  sortChronologically = (degrees) => {
    return degrees
      .sort((a, b) => {
        const dateA = parseISO(a.year)
        const dateB = parseISO(b.year)
        if (dateA && dateB) {
          if (isAfter(dateA, dateB)) {
            return -1
          } else {
            return 1
          }
        } else {
          return 0
        }
      })
  }

  createNewDiplome = () => {
    this.props.openDiplomeModal({
      freelance: this.props.freelance,
      onSubmit: this.props.submit,
    })
  }

  editExistingDiplome = (offset) => {
    return () => {
      this.props.openDiplomeModal({
        freelance: this.props.freelance,
        onSubmit: this.props.submit,
        onClose: this.onClose,
        offset
      })
    }
  }

  deleteDiplome = (offset) => {
    return () => {
      this.props.openDeleteDiplomeModal({
        freelance: this.props.freelance,
        offset,
        onSubmit: this.props.submit
      })
    }
  }

  onClose = (degrees) => {
    this.setState({degrees: this.sortChronologically(degrees)})
  }

  save = async () => {
    this.setState({loading: true})
    try {
      await this.props.submit({
        user: this.props.user,
        freelance: this.props.freelaance,
      })
    } catch (e) {
      console.warn(e)
    } finally {
      this.setState({loading: false})
      this.props.onFormSuccess()
    }
  }

  addElementTo = (field) => {
    return (values) => {
      const newValues = [...(this.props.freelance?.[field] ?? [])]
      newValues.push(values)

      return this.props.submit({
        freelance: {
          [field]: newValues
        },
      }).catch(handleResponseErrors)
    }
  }

  removeElementFrom = (field, offset) => {
    return async () => {
      const newValues = [...(this.props.freelance?.[field] ?? [])]
      newValues.splice(offset, 1)

      try {
        await this.props.submit({
          freelance: {
            [field]: newValues
          }
        })
      } catch (e) {
        console.warn(e)
      }
    }
  }

  /* IT Skills*/
  createNewItSkills = () => {
    this.props.openItSkillModal({
      freelance: this.props.freelance,
      onSubmit: this.props.submit,
    })
  }

  addLanguage = () => {
    return async (values) => {
      const newLanguage = { language: values.language[0].id, name: values.language[0].name, level: values.level }
      const languages = [...this.state.languages]

      if (languages.some((language) => language.language === newLanguage.language)) {
        return toastr.error('Ce langage est déjà renseigné')
      }

      languages.push(newLanguage)

      try {
        await api.freelanceLanguages.add({
          freelance: this.props.freelance.id,
          language: newLanguage.language,
          level: newLanguage.level
        })

        this.setState({ languages })
      } catch (e) {
        handleResponseErrors(e)
      }
    }
  }

  removeLanguage = (offset) => {
    return async () => {
      const languages = [...this.state.languages]
      const removed = languages.splice(offset, 1)[0]

      try {
        await api.freelanceLanguages.delete({
          freelance: this.props.freelance.id,
          language: removed.language
        })

        this.setState({ languages })
      } catch (e) {
        console.warn(e)
      }
    }
  }

  render() {
    const hasDegrees = !isEmpty(this.state.degrees)

    return (
      <FreelancePage className="p-5">

        <h2 className="text-center">Formations</h2>
        <CardRow justify="center">
          <CardCol>
              Renseignez ici vos différents niveaux de diplômes, certifications, outils informatiques et langues
          </CardCol>
        </CardRow>

        <h4 id="degrees" className="text-center mt-5 mb-4">Diplômes</h4>
        {!hasDegrees
          ? <div className="callout callout-secondary text-center col-md-7 mx-auto">
            <p>
                Afin de finaliser votre profil et être plus attractif auprès des recruteurs
                veuillez saisir vos diplômes / formations.
            </p>
            <button
              type="button"
              style={{whiteSpace: 'break-spaces', lineHeight: 1.5}}
              onClick={this.createNewDiplome}
              className="btn btn-outline-primary">
              <Plus/> Ajouter un diplôme / formation
            </button>
          </div>
          : <div className="has-degrees">
            <CardRow className="has-degrees-cta-row" justify={'flex-end'}>
              <CardCol>
                <button
                  type="button"
                  onClick={this.createNewDiplome}
                  style={{whiteSpace: 'break-spaces', lineHeight: 1.5}}
                  className="btn btn-outline-primary">
                  <Plus/> Ajouter un diplôme / formation
                </button>
              </CardCol>
            </CardRow>

            {this.state.degrees.map((diplome, offset) => (
              <div className="callout callout-parcours" key={`formations-degree-${offset}`}>
                <CardRow className="has-degrees-list-row">

                  <CardCol flex={1} className="formations-degree-card">
                    {(diplome.name || diplome.year) &&
                      <div >
                        {diplome.name && <b>{diplome.name}</b>}
                        {diplome.name && diplome.year && <span> - </span>}
                        {diplome.year && <Date format="yyyy" date={diplome.year}/>}
                      </div>
                    }
                    <div className={(diplome.name) ? 'mt-2' : ''}>
                      {nl2br(diplome.description)}
                    </div>
                  </CardCol>

                  <CardCol>
                    <div className="controls">
                      <div onClick={this.editExistingDiplome(offset)}
                        className="btn btn btn-outline-primary btn-round btn-sm">
                        <Edit/>
                      </div>
                      <div onClick={this.deleteDiplome(offset)} className="btn btn btn-outline-danger btn-round btn-sm">
                        <Trash/>
                      </div>
                    </div>
                  </CardCol>
                </CardRow>
              </div>
            ))}
          </div>
        }

        <h4 className="text-center mt-5 mb-4" id="certifications">Certifications</h4>

        <CertificationForm onSubmit={this.addElementTo('certifications')}/>

        {/*<div className="certifications">*/}
        <CardRow style={{flexWrap: 'wrap'}} justify={'flex-start'} gap="10px">
          {this.state.certifications.map((certification, index) => (
            <CardCol key={`formations-certifications-${certification.id}`}>
              <div className="callout">
                <CardRow style={{paddingRight:"3px"}}>
                  <CardCol flex={1}>
                    <b>{certification.label}</b>
                    {certification.date && <span> - <Date format="yyyy" date={certification.date}/></span>}
                  </CardCol>
                  <CardCol >
                    <button
                      onClick={this.removeElementFrom('certifications', index)}
                      type="button"
                      className="btn btn-round btn-sm btn-outline-danger ml-3"
                    >
                      <Trash/>
                    </button>
                  </CardCol>
                </CardRow>
              </div>
            </CardCol>
          ))}
        </CardRow>
        {/*</div>*/}

        <h4 className="text-center mt-5 mb-4" id="tools">Logiciels et outils informatiques</h4>

        <ItSkillForm
          onSubmit={this.addElementTo('it_skills')}
        />

        <div className="it_skills">
          {this.state.itSkills && <Fragment>
            {this.state.itSkills.map((itSkill, index) => (
              <div key={`it-skills-${itSkill.id}`} className="callout d-inline-block mr-3 mt-0 mb-3">
                <b>{itSkill.name}</b>
                <button
                  onClick={this.removeElementFrom('it_skills', index)}
                  type="button"
                  className="btn btn-round btn-sm btn-outline-danger ml-3"
                >
                  <Trash/>
                </button>
              </div>
            ))}
          </Fragment>}
        </div>

        <h4 className="text-center mt-5 mb-4" id="languages">Langues</h4>

        <LanguageForm onSubmit={this.addLanguage()}/>
        <div className="languages">
          {this.state.languages.map((language, index) => (
            <div key={`formations-language-${index}`} className="callout d-inline-block mr-3 mt-0 mb-3">
              <b className="text-capitalize">{language.name}</b> - {this.state.languageLevels[language.level]}
              <button
                onClick={this.removeLanguage(index)}
                type="button"
                className="btn btn-round btn-sm btn-outline-danger ml-3"
              >
                <Trash/>
              </button>
            </div>
          ))}
        </div>

        <Loader visible={this.state.loading}>
          Sauvegarde en cours...
        </Loader>
      </FreelancePage>
    )
  }
}

export default connectModal({DiplomeModal, DeleteDiplomeModal, ItSkillModal}, Formations)
